import { render, staticRenderFns } from "./prepare-invitation.vue?vue&type=template&id=4678ecf8&scoped=true&"
import script from "./prepare-invitation.vue?vue&type=script&lang=js&"
export * from "./prepare-invitation.vue?vue&type=script&lang=js&"
import style0 from "./prepare-invitation.vue?vue&type=style&index=0&id=4678ecf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678ecf8",
  null
  
)

export default component.exports